import { Col, Flex, Row } from 'antd';
import { DateTime, WeekdayNumbers } from 'luxon';
import React from 'react';
import { useSelector } from 'react-redux';

import { BORDER_MAIN, COUNT_DAY_IN_WEEK, WEEKEND_DAYS, WIDTH_COLUMN_CALENDAR_TIME } from '../const';
import { getCustomWeekNumber } from '../functions';
import { RootState } from '../store';

const CalendarHeaderMonth = () => {
    const currentDate = useSelector<RootState, string>((state) => state.calendar.currentDate);

    const renderDay = (day: WeekdayNumbers) => {
        const date = DateTime.fromObject({
            weekday: day,
            weekNumber: getCustomWeekNumber(DateTime.fromISO(currentDate)),
        });
        const colorText = WEEKEND_DAYS.has(day) ? 'red' : 'black';

        return (
            <Flex key={day} justify={'center'} vertical align={'center'} style={{ padding: 10 }}>
                <div style={{ color: colorText }}>{date.toFormat('ccc')}</div>
            </Flex>
        );
    };

    return (
        <>
            <Row>
                <Col
                    style={{
                        borderRight: BORDER_MAIN,
                        borderBottom: BORDER_MAIN,
                        width: WIDTH_COLUMN_CALENDAR_TIME,
                    }}
                ></Col>
                <Col
                    style={{
                        borderBottom: BORDER_MAIN,
                        width: `calc(100% - ${WIDTH_COLUMN_CALENDAR_TIME}px)`,
                    }}
                >
                    <Flex justify={'space-around'}>
                        {Array.from<number>({ length: COUNT_DAY_IN_WEEK }).map((_, day) =>
                            renderDay((day + 1) as WeekdayNumbers),
                        )}
                    </Flex>
                </Col>
            </Row>
        </>
    );
};

export default CalendarHeaderMonth;
